import { z } from 'zod';
export const OnboardingStatus = z.enum([
    'created', // created in admin dashboard
    'ready-to-start', // ready to start onboarding (example: shopify app created)
    'completed', // onboarding finished (psp created, company created, etc.)
    /** @todo define if pertinent */
    'waiting-to-start',
    /** @todo define if pertinent */
    'in-progress',
    /** @todo define if pertinent */
    'blocked',
]);
export const OnboardingSchema = z.object({
    id: z.string(),
    status: OnboardingStatus,
    step: z.enum(['cms', 'psp', 'company', 'choose-cms']).optional(),
    error: z.record(z.string(), z.unknown()).optional(),
    emailData: z
        .object({
        sentAt: z.string(),
        link: z.string(),
        expiresAt: z.string(),
        token: z.string(),
    })
        .optional(),
    authData: z
        .object({
        jwt: z.string().optional(),
    })
        .optional(),
    input: z.record(z.string(), z.unknown()),
    createdAt: z.preprocess((value) => {
        if (typeof value === 'string' || value instanceof Date) {
            return new Date(value);
        }
        return value;
    }, z.date()),
    deletedAt: z
        .preprocess((value) => {
        if (typeof value === 'string' || value instanceof Date) {
            return new Date(value);
        }
        return value;
    }, z.date())
        .optional(),
    updatedAt: z.preprocess((value) => {
        if (typeof value === 'string' || value instanceof Date) {
            return new Date(value);
        }
        return value;
    }, z.date()),
});
//# sourceMappingURL=onboarding.js.map